var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 7H1.83333L1.83333 3H9.16667L9.16667 7ZM8.25 1C8.25 0.734783 8.15342 0.480429 7.98151 0.292892C7.80961 0.105356 7.57645 0 7.33333 0H3.66667C3.42355 0 3.19039 0.105356 3.01849 0.292892C2.84658 0.480429 2.75 0.734783 2.75 1H1.83333C1.3471 1 0.880788 1.21071 0.536971 1.58579C0.193154 1.96086 0 2.46957 0 3L0 18C0 18.5304 0.193154 19.0391 0.536971 19.4142C0.880788 19.7893 1.3471 20 1.83333 20H9.16667C9.6529 20 10.1192 19.7893 10.463 19.4142C10.8068 19.0391 11 18.5304 11 18L11 3C11 2.46957 10.8068 1.96086 10.463 1.58579C10.1192 1.21071 9.6529 1 9.16667 1H8.25Z",
    fill: "#20E89C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/BatteryIcon.64c96606e6d298bb714238897382f7b1.svg";
export { ForwardRef as ReactComponent };